import { render, staticRenderFns } from "./impsExtra.vue?vue&type=template&id=40625f28"
import script from "./impsExtra.vue?vue&type=script&lang=ts"
export * from "./impsExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports